import type { IValueAndUnit } from '@/interfaces/IValueAndUnit'
import type { IWheelsAndTiresSpecifications } from '@/interfaces/IWheelsAndTiresSpecifications'
import { Base, ValueAndUnit } from '@/models'

class WheelsAndTiresSpecifications extends Base implements IWheelsAndTiresSpecifications {
  driveType: string
  brakeSystem: string
  frontTrackWidth: IValueAndUnit<number>
  rearTrackWidth: IValueAndUnit<number>
  wheelbase: IValueAndUnit<number>
  frontWheelDiameter: IValueAndUnit<number>
  rearWheelDiameter: IValueAndUnit<number>
  rearAxle: IValueAndUnit<number>
  frontTyreType: string
  frontTyrePressure: IValueAndUnit<number>
  rearTyreType: string
  rearTyrePressure: IValueAndUnit<number>

  constructor(wheelsAndTiresSpecifications?: any) {
    super(wheelsAndTiresSpecifications)
    this.driveType = wheelsAndTiresSpecifications?.driveType
    this.brakeSystem = wheelsAndTiresSpecifications?.brakeSystem
    this.frontTrackWidth = new ValueAndUnit(wheelsAndTiresSpecifications?.frontTrackWidth)
    this.rearTrackWidth = new ValueAndUnit(wheelsAndTiresSpecifications?.rearTrackWidth)
    this.wheelbase = new ValueAndUnit(wheelsAndTiresSpecifications?.wheelbase)
    this.frontWheelDiameter = new ValueAndUnit(wheelsAndTiresSpecifications?.frontWheelDiameter)
    this.rearWheelDiameter = new ValueAndUnit(wheelsAndTiresSpecifications?.rearWheelDiameter)
    this.rearAxle = new ValueAndUnit(wheelsAndTiresSpecifications?.rearAxle)
    this.frontTyreType = wheelsAndTiresSpecifications?.frontTyreType
    this.frontTyrePressure = new ValueAndUnit(wheelsAndTiresSpecifications?.frontTyrePressure)
    this.rearTyreType = wheelsAndTiresSpecifications?.rearTyreType
    this.rearTyrePressure = new ValueAndUnit(wheelsAndTiresSpecifications?.rearTyrePressure)
  }
}

export default WheelsAndTiresSpecifications
